export const enum CalculatorExceptionType {
	DOUBLE_OPERATOR_ERROR = 'Forbidden double operator',
	NOT_NUMBER_ERROR = 'Forbidden double operator',
}

export const enum ExpressionExceptionType {
	INVALID_EXPRESSION = 'Invalid expression',
	INVALID_CHARACTER = 'Invalid character',
}
